import { CSSProperties } from "@material-ui/core/styles/withStyles";
// import { greys } from '@clockwise/web-commons/src/styles/color.styles';
// import { weight } from '@clockwise/web-commons/src/styles/type.styles';

const container: CSSProperties = {};

export const styles = {
  container,
};
